<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        name: 'app',
        components: {
        }
    };
</script>

<style lang="scss">
    body {
        margin: 0px;
        padding: 0px;
        /*background: url(assets/bg1.jpg) center !important;
        background-size: cover;*/
        background: #1F2D3D;
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
    }

    #app {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 100%;
    }

    .el-submenu [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .el-menu-item [class^=fa] {
        vertical-align: baseline;
        margin-right: 10px;
    }

    .toolbar {
        background: #fff;
        padding: 10px;
        .el-form-item {
            margin-bottom: 10px;
        }
    }
    .name_href_border{
        cursor:pointer;
        text-decoration:underline!important;
    }
    .color-red {
        color:#ff4949;
    }
    .color-blue {
        color: #0d638f;
    }
    .del_border {
        text-decoration:line-through!important;
    }
    .user-icon-img {
        width: 45px;
        height: 45px;
        margin-right: 12px;
        border-image-source: initial;
        border-image-slice: initial;
        border-image-width: initial;
        border-image-outset: initial;
        border-image-repeat: initial;
        border-radius: 50%;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(238, 238, 238);
    }
    .msg-icon-img {
        width: 45px;
        height: 45px;
        margin-right: 12px;
        border-image-source: initial;
        border-image-slice: initial;
        border-image-width: initial;
        border-image-outset: initial;
        border-image-repeat: initial;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(238, 238, 238);
    }
</style>



// WEBPACK FOOTER //
// App.vue?f799262a